<div style="overflow: auto; height: calc(100vh - 220px)">
    <p class="text-muted small mt-2">
        These are suggestions and are not saved. Ambiguous means more than one Viewpoint vendor is close, so the match is left for review.
    </p>
    @if (summary) {
        <div class="row g-3 mb-3">
            <div class="col-md-3">
                <div class="card text-bg-light h-100">
                    <div class="card-body">
                        <div class="text-muted small">Vendors matched</div>
                        <div class="fs-3 fw-bold">{{ summary.vendorMatchedPercent | number: '1.0-1' }}%</div>
                        <div class="small text-muted">{{ summary.matchedCount | number }} of {{ summary.vendorCount | number }}</div>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card text-bg-light h-100">
                    <div class="card-body">
                        <div class="text-muted small">Spend matched</div>
                        <div class="fs-3 fw-bold">{{ summary.spendMatchedPercent | number: '1.0-1' }}%</div>
                        <div class="small text-muted">{{ summary.matchedSpend | currency }} of {{ summary.totalSpend | currency }}</div>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card text-bg-light h-100">
                    <div class="card-body">
                        <div class="text-muted small">Ambiguous</div>
                        <div class="fs-3 fw-bold">{{ summary.ambiguousCount | number }}</div>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card text-bg-light h-100">
                    <div class="card-body">
                        <div class="text-muted small">Unmatched</div>
                        <div class="fs-3 fw-bold">{{ summary.unmatchedCount | number }}</div>
                    </div>
                </div>
            </div>
        </div>
    }
    <div class="row action-toolbar">
        <div class="col-12">
            <form class="form-inline">
                <action-toolbar-count [grid]="vendorGrid"></action-toolbar-count>
                <grid-export [grid]="gridVistaVendors" [name]="'Purchased Material Vista Vendors'"></grid-export>
            </form>
        </div>
    </div>
    <grid-column-group [grid]="vendorGrid"></grid-column-group>
    <wj-flex-grid
        id="gridVistaVendors"
        #gridVistaVendors
        style="height: 420px"
        [isReadOnly]="true"
        (initialized)="vendorGrid.initialize(gridVistaVendors)"
        (destroy)="vendorGrid.destroy()"
        [itemsSource]="vendorGrid.view"
    >
        <wj-flex-grid-filter></wj-flex-grid-filter>
        <wj-flex-grid-column [header]="'Invoice vendor'" [binding]="'displayName'" [width]="260" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Kind'" [binding]="'kind'" [width]="90" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Lines'" [binding]="'lineCount'" [width]="90" [format]="'n0'" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Spend'" [binding]="'spend'" [width]="130" [format]="'c2'" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Status'" [binding]="'status'" [width]="120" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Vista vendor'" [binding]="'vistaVendor'" [width]="120" [format]="'n0'" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Vista name'" [binding]="'vistaName'" [width]="240" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Reason'" [binding]="'reason'" [width]="210" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Runner-up'" [binding]="'runnerUp'" [width]="240" [isReadOnly]="true"></wj-flex-grid-column>
    </wj-flex-grid>
    <grid-selection-calculation [grid]="gridVistaVendors"></grid-selection-calculation>
</div>
